import { actions as labelActions } from 'actions/labels';
import { actions as workflowActions } from 'actions/workflow';

const initialState = {
  id: null,
  type: '',
  data: {},
  passwordEntered: false
};

const workflow = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case workflowActions.setWorkflow:
      return {
        ...state,
        id: payload.id,
        type: payload.type
      };
    case labelActions.initLabels:
      return {
        ...state,
        data: payload.workflow
      };
    case workflowActions.enterPassword:
      return {
        ...state,
        passwordEntered: true
      };
    default:
      return state;
  }
};

export default workflow;



// WEBPACK FOOTER //
// ./src/reducers/workflow.js